"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const reactstrap_1 = require("reactstrap");
const date_picker_1 = require("@festival/component/form/date-picker");
const loader_1 = require("@festival/component/loader");
const formik_1 = require("formik");
const Yup = require("yup");
const Base = require("@festival/component/form/line");
const date_fns_1 = require("date-fns");
const fr_1 = require("date-fns/locale/fr");
const cn = require("classnames");
class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.closeSuccessAlert = () => {
            this.setState({
                submited: false
            });
        };
        this.state = {
            submited: false
        };
    }
    render() {
        const initialValues = {
            lastname: '',
            firstname: '',
            mail: '',
            phone: '',
            birthdate: null,
            univers: [],
            why: '',
            what: '',
            availabilities: []
        };
        const schema = Yup.object().shape({
            firstname: Yup.string()
                .required('staff.error.common.required'),
            lastname: Yup.string()
                .required('staff.error.common.required'),
            mail: Yup.string()
                .required('staff.error.common.required'),
            phone: Yup.string()
                .required('staff.error.common.required'),
            birthdate: Yup.date()
                .nullable()
                .required('staff.error.common.required'),
            univers: Yup.array()
                .of(Yup.string())
                .min(1, 'staff.error.common.required'),
            why: Yup.string()
                .required('staff.error.common.required'),
            what: Yup.string()
                .required('staff.error.common.required'),
            availabilities: Yup.array()
                .of(Yup.string())
                .min(1, 'staff.error.common.required'),
        });
        const { staffStore, intl, editionStore, tagStore, pageConfigurationStore } = this.props;
        if (!staffStore || !editionStore || !tagStore || !pageConfigurationStore) {
            return null;
        }
        const staff = pageConfigurationStore.get('staff');
        if (!staff) {
            return null;
        }
        if (!staff.complete) {
            return React.createElement(loader_1.default, null);
        }
        const staffComplete = staff;
        if (!staffComplete.details) {
            return null;
        }
        if (this.state.submited) {
            return (React.createElement(reactstrap_1.Alert, { color: "success", className: "m-5", toggle: this.closeSuccessAlert },
                React.createElement(react_intl_1.FormattedMessage, { id: "staff.form.success" })));
        }
        const date18YearsBefore = new Date(editionStore.current.referenceDate);
        date18YearsBefore.setFullYear(date18YearsBefore.getFullYear() - 18);
        const slots = [];
        const days = [];
        const before = staffComplete.details.nbDaysBefore;
        const during = editionStore.current.nbDays;
        const after = staffComplete.details.nbDaysAfter;
        const nbDays = before + during + after;
        for (let i = 0; i < nbDays; i++) {
            const d = date_fns_1.addDays(editionStore.current.referenceDate, i - before);
            days.push(d);
            slots.push({
                date: d,
                before: i < before,
                during: i >= before && i < before + during,
                after: i >= before + during
            });
        }
        const groupUnivers = tagStore.getGroup('univers');
        const univers = groupUnivers ? tagStore.getFilteredTags({ group: groupUnivers, type: 'guest' }) : [];
        return (React.createElement("div", { id: "staff" },
            React.createElement("h1", null,
                React.createElement(react_intl_1.FormattedMessage, { id: "staff.form.title" })),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: intl.formatMessage({ id: 'staff.form.content' }) } }),
            React.createElement(formik_1.Formik, { initialValues: initialValues, validationSchema: schema, validateOnBlur: false, onSubmit: (values, actions) => {
                    staffStore.save(values)
                        .then(() => {
                        actions.setSubmitting(false);
                        actions.resetForm();
                        this.setState({
                            submited: true
                        });
                    })
                        .catch((response) => {
                        actions.setSubmitting(false);
                        if (response.data.violations !== undefined && Object.keys(response.data.violations).length > 0) {
                            for (const key of Object.keys(response.data.violations)) {
                                const messages = [];
                                for (const violation of response.data.violations[key]) {
                                    messages.push(violation);
                                }
                                actions.setFieldError(key, messages.join(', '));
                            }
                        }
                    });
                } }, props => {
                return (React.createElement(reactstrap_1.Form, { onSubmit: props.handleSubmit },
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "firstname", title: "staff.contact.form.firstname" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "firstname", name: "firstname", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.firstname || '' }),
                                props.errors.firstname !== undefined && props.touched.firstname && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.firstname }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "lastname", title: "staff.contact.form.lastname" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "lastname", name: "lastname", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.lastname || '' }),
                                props.errors.lastname !== undefined && props.touched.lastname && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.lastname }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "birthdate", title: "staff.contact.form.birthdate" },
                                React.createElement(date_picker_1.default, { selected: props.values.birthdate, onChange: date => props.setFieldValue('birthdate', date), invalid: props.errors.birthdate !== undefined, dateFormat: "d MMMM yyyy", maxDate: date18YearsBefore, showMonthDropdown: true, showYearDropdown: true, dropdownMode: "select" }),
                                props.errors.birthdate !== undefined && props.touched.birthdate && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.birthdate })))))),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "mail", title: "staff.contact.form.mail" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "mail", name: "mail", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.mail || '' }),
                                props.errors.mail !== undefined && props.touched.mail && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.mail }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "phone", title: "staff.contact.form.phone" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "phone", name: "phone", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.phone || '' }),
                                props.errors.phone !== undefined && props.touched.phone && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.phone })))))),
                    React.createElement(Base.Line, { field: "univers", title: "staff.contact.form.univers", inline: 4 },
                        univers.map((tag, index) => (React.createElement(reactstrap_1.CustomInput, { key: index, type: "switch", id: `univers_${tag.code}`, name: "univers", inline: true, onChange: () => {
                                const list = props.values.univers;
                                const index = list.indexOf(tag.code);
                                if (index < 0) {
                                    list.push(tag.code);
                                }
                                else {
                                    list.splice(index, 1);
                                }
                                props.setFieldValue('univers', list);
                            }, onBlur: props.handleBlur, label: tag.label, checked: props.values.univers.indexOf(tag.code) >= 0 }))),
                        props.errors.univers !== undefined && props.touched.univers && (React.createElement(reactstrap_1.FormFeedback, null,
                            React.createElement(react_intl_1.FormattedMessage, { id: props.errors.univers })))),
                    React.createElement(Base.Line, { field: "why", title: "staff.contact.form.why" },
                        React.createElement(reactstrap_1.Input, { type: "text", id: "why", name: "why", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.why || '' }),
                        props.errors.why !== undefined && props.touched.why && (React.createElement(reactstrap_1.FormFeedback, null,
                            React.createElement(react_intl_1.FormattedMessage, { id: props.errors.why })))),
                    React.createElement(Base.Line, { field: "what", title: "staff.contact.form.what" },
                        React.createElement(reactstrap_1.Input, { type: "text", id: "what", name: "what", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.what || '' }),
                        props.errors.what !== undefined && props.touched.what && (React.createElement(reactstrap_1.FormFeedback, null,
                            React.createElement(react_intl_1.FormattedMessage, { id: props.errors.what })))),
                    React.createElement(Base.Line, { field: "availabilities", title: "staff.contact.form.availabilities" },
                        React.createElement(reactstrap_1.Table, null,
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("td", null),
                                    slots.map((slot, index) => (React.createElement("th", { key: index, className: cn('text-center', { 'table-active': slot.during }) }, date_fns_1.format(slot.date, 'EEEE dd', { locale: fr_1.default })))))),
                            React.createElement("tbody", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null,
                                        React.createElement(react_intl_1.FormattedMessage, { id: "staff.contact.form.availabilities.am" })),
                                    slots.map((slot, index) => {
                                        const code = date_fns_1.format(slot.date, 'd') + '_am';
                                        return (React.createElement("td", { key: index, className: cn('text-center', { 'table-active': slot.during }) }, SlotInput(code, props)));
                                    })),
                                React.createElement("tr", null,
                                    React.createElement("th", null,
                                        React.createElement(react_intl_1.FormattedMessage, { id: "staff.contact.form.availabilities.pm" })),
                                    slots.map((slot, index) => {
                                        const code = date_fns_1.format(slot.date, 'd') + '_pm';
                                        return (React.createElement("td", { key: index, className: cn('text-center', { 'table-active': slot.during }) }, SlotInput(code, props)));
                                    })))),
                        props.errors.availabilities !== undefined && props.touched.availabilities && (React.createElement(reactstrap_1.FormFeedback, null,
                            React.createElement(react_intl_1.FormattedMessage, { id: props.errors.availabilities })))),
                    React.createElement(reactstrap_1.Button, { type: "submit", color: "primary", className: "text-white", disabled: props.isSubmitting },
                        props.isSubmitting ? (React.createElement("i", { className: "mdi mdi-loading mdi-spin mr-2" })) : (React.createElement("i", { className: "mdi mdi-chevron-right mr-2" })),
                        React.createElement(react_intl_1.FormattedMessage, { id: "staff.contact.form.submit" }))));
            })));
    }
}
exports.Contact = Contact;
exports.default = react_intl_1.injectIntl(mobx_react_1.inject('staffStore', 'editionStore', 'tagStore', 'pageConfigurationStore')(mobx_react_1.observer(Contact)));
const SlotInput = (code, props) => (React.createElement(reactstrap_1.CustomInput, { type: "checkbox", id: `slot_${code}`, name: "availabilities", inline: true, onChange: () => {
        const list = props.values.availabilities;
        const index = list.indexOf(code);
        if (index < 0) {
            list.push(code);
        }
        else {
            list.splice(index, 1);
        }
        props.setFieldValue('availabilities', list);
    }, onBlur: props.handleBlur, 
    //label={format(slot.date, 'EEEE dd', { locale: fr })}
    checked: props.values.availabilities.indexOf(code) >= 0 }));
